import { NavigationData } from 'components/Navigation/NavigationPage';
import i18n from 'i18next';
import { Company } from 'pages/Company/contexts/CompanyContext';
import { isMsp } from 'utils/isMsp';

export const companyNavigationData: NavigationData<Company> = {
    options: {
        title: i18n.t('company:navigation.options'),
        link: '/companies/:companyId/options',
    },
    children: {
        title: i18n.t('company:navigation.children'),
        link: '/companies/:companyId/children',
        isPermitted: (company) => isMsp(company),
    },
    sites: {
        title: i18n.t('company:navigation.sites'),
        link: '/companies/:companyId/sites',
        isPermitted: (company) =>
            company.company_type !== 'Environment Operator',
    },
    devices: {
        title: i18n.t('company:navigation.devices'),
        link: '/companies/:companyId/devices',
    },
    users: {
        title: i18n.t('company:navigation.users'),
        link: '/companies/:companyId/users',
        hints: ['show-view-company-accounts'],
    },
    'alert-settings': {
        title: i18n.t('company:navigation.alert_settings'),
        link: '/companies/:companyId/alert-settings',
    },
    logs: {
        title: i18n.t('company:navigation.logs'),
        link: '/companies/:companyId/logs',
    },
};
